export default "__VITE_ASSET__CwAWJR8F__"